import { Link } from "react-router-dom";

function Committee() {
  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center">Maratha Hitwardhak Mandal Comittee</th>
          </tr>
          <tr className="list">
            <td
              style={{
                fontSize: "15",
                fontWeight: "bold",
              }}
            >
              <ul>
                <li>
                  <Link to="/admin/founders">
                    <span>Mandal Founders</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/vishwasthamandal">
                    <span>Vishwastha Mandal</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/vidyamanmandal">
                    <span>Vidyaman Mandal</span>
                  </Link>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );

  return contents;
}

export default Committee;
